import { __assign, __rest } from "tslib";
import React from 'react';
import { StyledStarRating, StyledStarRatingFill, StyledSrOnly } from './star-rating.styled';
export var StarRating = function (_a) {
    var rating = _a.rating, _b = _a.type, type = _b === void 0 ? 'at' : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, className = _a.className, _d = _a.displayScreenReader, displayScreenReader = _d === void 0 ? true : _d, otherHTMLProperties = __rest(_a, ["rating", "type", "size", "className", "displayScreenReader"]);
    if (rating === null)
        return null;
    var maxStars = 5;
    var percentage = (rating / maxStars) * 100;
    var width = Math.min(percentage, 100);
    var currentClassName = [
        'atds-star-rating',
        "atds-star-rating--".concat(type),
        size && "atds-star-rating--".concat(size),
        className && className,
    ]
        .filter(Boolean)
        .join(' ');
    return (React.createElement(StyledStarRating, __assign({ size: size, type: type, className: currentClassName, "aria-hidden": "true" }, otherHTMLProperties),
        displayScreenReader && React.createElement(StyledSrOnly, null, "Rating: ".concat(rating, " out of ").concat(maxStars, " stars")),
        React.createElement(StyledStarRatingFill, { className: "atds-star-rating__fill", size: size, type: type, width: width })));
};
